import { useEffect } from "react";
import { SystemTypesList } from "../list/list";
import { logEvent } from "@shared/analytics/analytics";

export const Landing = () => {
  useEffect(() => {
    logEvent("system_types_landing_viewed");
  }, []);
  return (
    <div className="p-3">
      <div className="space-y-6">
        <div className="space-y-2">
          <p className="page-title">System Types Hierarchy</p>
          <p className="page-subtitle">
            Define and manage system types and their monitored parameters.
          </p>
        </div>
        <SystemTypesList />
      </div>
    </div>
  );
};
